module.exports = __webpack_public_path__ + "static/media/ti.c4cc2ab9.ico";